import routes from 'router/routes'
import system from 'settings/system'

import {
  isInventoryUrl,
  isInvoiceGroupDetailsUrl,
  isPaymentGroupDetailsUrl,
  isAccountGroupDetailsUrl,
  isSuspensionGroupDetailsUrl,
  isLateFeeDetailsUrl,
  isRentalFeeDetailsUrl,
  isDisposalFeeDetailsUrl,
  isReportingDetailsUrl,
  isConfiguredServiceDetailsUrl,
  isPaymentBatchDetailsUrl,
} from './validations'

const { title: systemTitle } = system

const allRoutes = Object.keys(routes.app)

const PAGE_TITLE = new Map<string, string>([
  // override any existing route here
  [routes.app.followUp, 'Follow Up'],
  [routes.app.createInvoices, 'Create Recurring Invoices'],
  [routes.app.createManualInvoices, 'Create Manual Invoices'],
  [routes.app.accountsReceivable, 'Accounts Receivable'],
  [routes.app.invoiceGroups, 'Invoice Groups'],
  [routes.app.paymentGroups, 'Payment Groups'],
  [routes.app.masterSequence, 'Master Sequence'],
  [routes.app.workOrdersReview, 'Work Orders Review'],
  [routes.app.lateFeeReview, 'Late Fee Review'],
  [routes.app.disposalTickets, 'Disposal Tickets'],
  [routes.app.accountGroups, 'Account Groups'],
  [routes.app.suspensionGroups, 'Suspension groups'],
  [routes.app.recentlyViewed, 'Recently viewed'],
  [routes.app.recentlyAdded, 'Recently added'],
  [routes.app.pricingServices, 'Services'],
  [routes.app.pricingServiceGroups, 'Service groups'],
  [routes.app.pricingFees, 'General fees'],
  [routes.app.pricingTaxes, 'Taxes'],
  [routes.app.pricingRentalFees, 'Rental fees'],
  [routes.app.pricingDisposalFees, 'Disposal fees'],
  [routes.app.pricingLateFees, 'Late fees'],
  [`${routes.app.search}/customer`, 'Customer Search'],
  [`${routes.app.search}/contact`, 'Contact Search'],
  [`${routes.app.search}/priced-service`, 'Priced Service Search'],
  [`${routes.app.search}/configured-service`, 'Configured Service Search'],
  [`${routes.app.search}/notes`, 'Notes Search'],
  [`${routes.app.search}/follow-up`, 'Follow Up Search'],
  [`${routes.app.search}/work-order`, 'Work Order Search'],
  [`${routes.app.settings}/attributes`, 'Business Line Attributes Settings'],
  [`${routes.app.settings}/create-configure`, 'Business Line Create & Configure Settings'],
  [`${routes.app.settings}/account-settings`, 'Account Settings'],
  [`${routes.app.settings}/tags`, 'Tags Settings'],
  [`${routes.app.settings}/customer-portal`, 'Customer Portal Settings'],
  [`${routes.app.settings}/people`, 'People Settings'],
  [`${routes.app.settings}/roles`, 'Roles Settings'],
  [`${routes.app.settings}/trucks`, 'Trucks Settings'],
  [`${routes.app.settings}/teams`, 'Teams Settings'],
  [`${routes.app.settings}/skills`, 'Skills Settings'],
  [`${routes.app.settings}/pricing-zones`, 'Pricing Zones Settings'],
  [`${routes.app.settings}/tax-zones`, 'Tax Zones  Settings'],
  [`${routes.app.settings}/customer-zones`, 'Customer Zones Settings'],
  [`${routes.app.settings}/general`, 'General Billing Settings'],
  [`${routes.app.settings}/customer-billing-profiles`, 'Customer Billing Profiles Settings'],
  [`${routes.app.settings}/general-ledger`, 'General Ledger Settings'],
  [`${routes.app.settings}/postcard-setup`, 'Postcard Setup Settings'],
  [`${routes.app.settings}/yards`, 'Yards Settings'],
  [`${routes.app.settings}/disposal-sites`, 'Disposal Sites Settings'],
  [`${routes.app.settings}/permits`, 'Permits'],
  [`${routes.app.settings}/business-information`, 'Business Information'],
  [`${routes.app.settings}/integrations`, 'Integrations'],
  [`${routes.app.settings}/container-types`, 'Container Types'],
  [`${routes.app.settings}/container-colors`, 'Container Colors'],
  [routes.app.selectAccount, 'Select Account'],
  [routes.app.paymentBatches, 'Payment Batches'],
  ['default', ''],
])

const capitalize = (word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()

export const getPageTitle = (page: string): string => {
  let title = PAGE_TITLE.get(page)

  if (!title) {
    const url = page.split('/').pop() ?? ''
    title = allRoutes.includes(url) ? capitalize(url) : PAGE_TITLE.get('default')
  }

  if (page.includes('reports')) return `${systemTitle} - Reports`

  if (page.includes('routes') && page.includes('work_orders')) return `${systemTitle} - Route Work Orders`

  if (page.includes('work-orders') && page.includes('details')) return `${systemTitle} - Work Order Details`

  if (page.includes('customer') && page.includes('details')) return `${systemTitle} - Customer Details`

  if (isInventoryUrl(page)) return `${systemTitle} - Inventory`

  if (isInvoiceGroupDetailsUrl(page)) return `${systemTitle} - Invoice Groups`

  if (isPaymentGroupDetailsUrl(page)) return `${systemTitle} - Payment Groups`

  if (isAccountGroupDetailsUrl(page)) return `${systemTitle} - Account Groups`

  if (isSuspensionGroupDetailsUrl(page)) return `${systemTitle} - Suspension Groups`

  if (isLateFeeDetailsUrl(page)) return `${systemTitle} - Late fees`

  if (isRentalFeeDetailsUrl(page)) return `${systemTitle} - Rental fees`

  if (isDisposalFeeDetailsUrl(page)) return `${systemTitle} - Disposal fees`

  if (isReportingDetailsUrl(page)) return `${systemTitle} - Reporting`

  if (isConfiguredServiceDetailsUrl(page)) return `${systemTitle} - Configured service`

  if (isPaymentBatchDetailsUrl(page)) return `${systemTitle} - Payment batch`

  if (page.startsWith(`${routes.app.messaging}/`)) return `${systemTitle} - Messaging`

  return `${systemTitle} - ${title}`
}
